import I18n from 'I18n';
import * as React from 'react';
import { EERIE } from 'HubStyleTokens/colors';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIIcon from 'UIComponents/icon/UIIcon';
import UISelect from 'UIComponents/input/UISelect';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WebhookPropertyMappingVisualization = ({
  sourceLabel,
  sourceSelectProps,
  destinationLabel,
  destinationSelectProps,
  destinationHelpNode
}) => {
  return /*#__PURE__*/_jsxs(UIFlex, {
    justify: "between",
    align: "end",
    gap: 20,
    children: [/*#__PURE__*/_jsx(UIBox, {
      grow: 1,
      alignSelf: "start",
      children: /*#__PURE__*/_jsx(UIFormControl, {
        label: sourceLabel,
        required: true,
        children: /*#__PURE__*/_jsx(UISelect, Object.assign({}, sourceSelectProps))
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      shrink: 0,
      alignSelf: destinationHelpNode ? 'center' : 'end',
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "dataSyncRight",
        screenReaderText: I18n.text('automation-ui-enrollment.webhookWizard.associatingObject.iconAccessibilityLabel'),
        size: "xs",
        color: EERIE
      })
    }), /*#__PURE__*/_jsxs(UIBox, {
      grow: 1,
      alignSelf: "start",
      children: [/*#__PURE__*/_jsx(UIFormControl, {
        label: destinationLabel,
        required: true,
        children: /*#__PURE__*/_jsx(UISelect, Object.assign({}, destinationSelectProps))
      }), destinationHelpNode]
    })]
  });
};
export default WebhookPropertyMappingVisualization;